export const EMPLOYEE_APPLIED_LEAVES_FOR_USERS = 'employeeLeaveManagementForUser@appliedLeaves';

export default {
    [EMPLOYEE_APPLIED_LEAVES_FOR_USERS]: {
        url: 'leave/get/all',
    }
};


